import LoadingSpinner from "../../components/GlobalLoading";
import { useDashboardData } from "./dashboardData";
import SearchInput from "./components/SearchInput";
import CertificateTable from "./components/CertificateTable";
import EmptyState from "./components/EmptyState";
import ErrorModal from "./components/ErrorModal";
import ViewDetailsModal from "./components/ViewDetailsModal";
import searchPromptIcon from "../../assets/images/searchPromptIcon.png";

import "./index.scss";

const Dashboard = () => {
  const {
    mobile,
    setMobile,
    imei,
    setImei,
    getCertificateListApi,
    getCertificateByImeiApi,
    mobileSearchCertificate,
    setMobileSearchCertificate,
    searchData,
    setSearchData,
    hasSearched,
    setHasSearched,
    isLoading,
    showError,
    handleClose,
    errorMessage,
    handleViewDetails,
    selectedRow,
    isModalOpen,
    handleCloseModal,
  } = useDashboardData();

  const handleMobileChange = (e) => {
    const val = e.target.value.replace(/\D/g, "");
    setImei("");
    setMobile(val);
  };

  const handleMobileClear = () => {
    setMobile("");
    setHasSearched(false);
    setMobileSearchCertificate([]);
    setSearchData([]);
  };

  const handleImeiChange = (e) => {
    const val = e.target.value.replace(/\D/g, "");
    setImei(val);
    setMobile("");
  };

  const handleImeiClear = () => {
    setImei("");
    setHasSearched(false);
    setSearchData([]);
    setMobileSearchCertificate([]);
  };

  return (
    <div className="dashboard">
      <h5 className="dashboard__title">
        Search for your certificate by Mobile Number or IMEI.
      </h5>

      <div className="dashboard__search-container">
        <SearchInput
          value={mobile}
          onChange={handleMobileChange}
          onClear={handleMobileClear}
          onSearch={getCertificateListApi}
          placeholder="Search by Mobile Number"
          maxLength={10}
          buttonText="Search by Mobile"
        />

        <SearchInput
          value={imei}
          onChange={handleImeiChange}
          onClear={handleImeiClear}
          onSearch={getCertificateByImeiApi}
          placeholder="Search by IMEI"
          maxLength={15}
          buttonText="Search by IMEI"
        />
      </div>

      {hasSearched && (
        <>
          <CertificateTable
            data={mobileSearchCertificate}
            onViewDetails={handleViewDetails}
          />
          <CertificateTable
            data={searchData}
            onViewDetails={handleViewDetails}
          />

          {mobileSearchCertificate?.length === 0 &&
            searchData?.length === 0 && (
              <EmptyState
                type="no-results"
                icon={require("../../assets/images/NoDataFound.jpg")}
                title="No Certificates found."
                subtitle="Please check and try again."
              />
            )}
        </>
      )}

      {!hasSearched && (
        <EmptyState
          type="prompt"
          icon={searchPromptIcon}
          title="Please search with Mobile Number or IMEI"
          subtitle="Enter a Mobile Number or IMEI to view your certificate details."
        />
      )}

      <ErrorModal
        show={showError}
        onClose={handleClose}
        message={errorMessage}
      />

      <ViewDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        data={selectedRow}
      />

      <LoadingSpinner open={isLoading} />
    </div>
  );
};

export default Dashboard;
